function PropertyManagementController(){
	this.className			= "PropertyManagementController";
	this.glob				= ["/property-management**"];
}
PropertyManagementController.inheritsFrom( PageController );
PropertyManagementController.prototype.swap = function(onComplete){

	this.baseController  = Aviator.get("baseController")
    this.topicController = Aviator.get("topicController");

    this.topicController.scrollToFees();

    this.configTopicImageSymbolAnimation();

    this.imageController = this.baseController.getImageController();
    this.imageLoadedOrFailedDelegate =  (e) => {
        if(!e.image) return; //Early ones aren't ready with an image
        this.animationControllers.forEach(a => a.refresh());
    };

    this.imageController.addListener("refresh",this.imageLoadedOrFailedDelegate);
    this.imageController.addListener("failed",this.imageLoadedOrFailedDelegate);

    this.setupAnimations();

	Preloader2.add("/assets/images/backgrounds/planks.svg").then(() => {
		//Add a delay to all it to render
		setTimeout(() => onComplete(), 10);
	});

    return false;
}
PropertyManagementController.prototype.on = function(onComplete){
    
    return true;    
}
PropertyManagementController.prototype.off = function(onComplete){
    if(this.imageController){
        if(this.imageLoadedOrFailedDelegate) this.imageController.removeListener("refresh",this.imageLoadedOrFailedDelegate);
        if(this.imageLoadedOrFailedDelegate) this.imageController.removeListener("failed",this.imageLoadedOrFailedDelegate);
    }
    this.animationControllers?.forEach(ac => {
        ac.destroy();
    });
    this.animationControllers = [];

    return true;
}

PropertyManagementController.prototype.setupAnimations = function () {
    new AnimationController({
        containerSelector: '#our-process',
        triggerStart: 'top 50%',
        triggerEnd: 'top top',
        showMarkers: false,
        once: true,
        onScroll: false,
        items: [{
            selector: '.js-stat-item',
            start: { opacity: 0 },
            end: { opacity: 1 },
            options: {
                duration: 0.5,
                stagger: 0.25
            }
        }],
    });

    /*
    new AnimationController({
        containerSelector: '#testimonials',
        triggerStart: 'top 50%',
        triggerEnd: 'top top',
        showMarkers: false,
        once: true,
        onScroll: false,
        items: [{
            selector: '.js-testimonial-item',
            start: { opacity: 0 },
            end: { opacity: 1 },
            options: {
                duration: 0.5,
                stagger: 0.1
            }
        }],
    });
    */
}

PropertyManagementController.prototype.configTopicImageSymbolAnimation = function () {

    if (this.log) console.log(`%c[PropertyManagementController]`, 'background:cyan', `configTopicImageSymbolAnimation`);

    this.animationControllers = [];

    const topicImageSymbolList = document.querySelectorAll('.topic-image-symbol');
    topicImageSymbolList.forEach((topicImageSymbol, index) => {
        const containerSelector = `#topic-image-symbol-${index}`;

        const startX = (index%2==0) ? 8 : -8;
        const topicSymbols = [
            {
                selector: `${containerSelector} .topic-symbol`,
                start: {
                    x: startX,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                },
                duration: 1,
            },
        ]


        var animationController = new AnimationController({
            containerSelector: containerSelector,
            items: topicSymbols,
            triggerStart: 'top bottom',
            triggerEnd: 'top 30%',
            showMarkers: false
        });

        this.animationControllers.push(animationController);
    })
}

PropertyManagementController.prototype.showTestimonials = function (testimonialArray, limit=null) {
    if (window.innerWidth < 1000) {
		// only show the first 3 testimonials
        testimonialArray.forEach((testimonial, index) => {
			if (index > limit) {
                testimonial.style.display = 'none';
            }
        });

    } else {
        testimonialArray.forEach((testimonial, index) => {
            testimonial.style.display = 'block';
        });
    }
};